import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToBrief } from "@/lib/scroll";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, testid }) => (
  <div className="flex items-center gap-3" data-testid={testid}>
    {index && <span className="ff-mono text-xs text-[#C7FF3C]">{index}</span>}
    <span className="ff-mono text-xs uppercase tracking-[0.3em] text-zinc-500">{children}</span>
    <span className="h-px flex-1 max-w-[80px] bg-zinc-800" />
  </div>
);

export const CtaButton = ({
  children = "Submit brief for free sample",
  testid = "cta-button",
  variant = "solid",
  className = "",
}) => {
  const base =
    "group relative inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60";
  const styles =
    variant === "solid"
      ? "bg-[#C7FF3C] text-black hover:bg-[#b4ec2a]"
      : "border border-zinc-700 text-white hover:border-[#C7FF3C] hover:text-[#C7FF3C] hover:bg-white/5";
  return (
    <button data-testid={testid} onClick={scrollToBrief} className={`${base} ${styles} ${className}`}>
      <span>{children}</span>
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );
};
